import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { DataManager, WebApiAdaptor, Query } from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, RowSelectEventArgs, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { isNumber } from 'highcharts';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { BancoService, ComunidadService, ConsorcioService, CuentaService, MenuFuncionService, MonedaService, PersonaService, ProveedorService, TipoDocumentoService, UnidadFuncionalService } from '../../../../../src/app/shared/services';

import { GridPageSettings, DialogCuentaSearchComponentRequestDto, DialogCuentaSearchComponentResponseDto, SearchComunidadRequest, SearchConsorcioRequest, Proveedor, TipoDocumento, SearchPersonaRequestDto, DialogConfirmResponse, DialogConfirmRequest, SavePersonaDto, MenuFuncionCodes, PedidoComunidadRolEnum, TenantEnum, SearchTipoDocumentoRequest } from '../../../../../src/app/shared/model';
import { TenantFeatureFlags, Comunidad, Consorcio, Cuenta, UnidadFuncional, Persona, DialogPersonaSearchComponentRequestDto, DialogPersonaSearchComponentResponseDto } from '../../../../../src/app/shared/model';
import { SearchUnidadFuncionalRequest, SearchCuentaRequest, Moneda, SearchMonedaRequest, SearchProveedorRequest, SearchBancoRequest, Banco } from '../../../../../src/app/shared/model';

import { DialogPersonaSearchComponent } from '../../usuarios/components/dialogPersonaSearch.component';
import { DialogConfirmComponent } from '../../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-dialogCuentaSearch',
  templateUrl: 'dialogCuentaSearch.component.html',
  styleUrls: ['./dialogCuentaSearch.component.css']
})

export class DialogCuentaSearchComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;

  tenantFeatureFlags: TenantFeatureFlags;
  monedaId: number | null;
  moneda: string | null;

  formGroup: FormGroup;
  searchForm: FormGroup;
  proveedorFormGroup: FormGroup;
  personaFormGroup: FormGroup;

  isMonedaSearching: boolean = false;
  isCuentaSearching: boolean = false;
  isPersonaSearching: boolean = false;
  isConsorcioSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isProveedorAutoSearching: boolean = false;
  isUnidadesFuncionalesSearching: boolean = false;
  isBancoSearching: boolean = false;
  isTipoDocumentoSearching: boolean = false;
  isPersonaDataSearching: boolean = false;
  isSelecting: boolean = false;
  isRosbaco: boolean = false;
  rol: PedidoComunidadRolEnum;
  rolTipo = PedidoComunidadRolEnum;
  canPersonaAdd: boolean = false;
  canTenantAdmin: boolean = false;
  canAsociarPersona: boolean = false;
  canAsociarProveedor: boolean = false;
  canAsociarConsorcio: boolean = false;
  canAsociarComunidad: boolean = false;
  canAsociarUnidadFuncional: boolean = false;
  verSoloCuentasConSaldo: boolean = true;
  createNewCuenta: boolean = false;
  createNewPersona: boolean = false;
  showCuit: boolean = true;
  nuevaPersona: boolean = false;

  public monedasList: Moneda[];
  public bancosList: Banco[];
  ufComunidadList: Comunidad[];
  ufComunidad: Comunidad | null;

  comunidadList: Comunidad[];
  consorcioList: Consorcio[];
  filteredProveedorList: Proveedor[];
  cuentaList: Cuenta[];
  ufList: UnidadFuncional[];
  tipoDocumentoList: TipoDocumento[];

  cuenta: Cuenta | null = null;
  persona: Persona | null = null;
  proveedor: Proveedor | null = null;
  consorcio: Consorcio | null = null;
  comunidad: Comunidad | null = null;
  unidadFuncional: UnidadFuncional | null = null;
  personaSearchResult: Persona | null = null;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public input: DialogCuentaSearchComponentRequestDto,
    private dialogRef: MatDialogRef<DialogCuentaSearchComponent>,
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private menuService: MenuFuncionService,
    private monedaService: MonedaService,
    private bancoService: BancoService,
    private tipoDocumentoService: TipoDocumentoService,
    private comunidadService: ComunidadService,
    private consorcioService: ConsorcioService,
    private proveedorService: ProveedorService,
    private unidadFuncionalService: UnidadFuncionalService,
    private personaService: PersonaService,
    private cuentaService: CuentaService,
  ) {
    this.tenantFeatureFlags = this.input?.FeatureFlags;
    this.monedaId = this.input?.MonedaId;
    this.moneda = this.input?.Moneda;
    this.verSoloCuentasConSaldo = (this.input?.VerCuentasConSaldo ?? false);

    this.buildForm();
  }

  ngOnInit(): void {
    this.canAsociarPersona = (this.input?.MostrarTabPersona ?? false);
    this.canAsociarProveedor = (this.input?.MostrarTabProveedor ?? false);
    this.canAsociarConsorcio = (this.input?.MostrarTabConsorcio ?? false) && this.tenantFeatureFlags?.HabilitarGestionConsorcio;
    this.canAsociarComunidad = (this.input?.MostrarTabComunidad ?? false);
    this.canAsociarUnidadFuncional = (this.input?.MostrarTabUnidadFuncional ?? false) && this.tenantFeatureFlags?.HabilitarGestionUf;

    this.menuService.checkMenu(MenuFuncionCodes.PERSONA_ADD).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canPersonaAdd = true;
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.loadView();
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };
    

    this.getComunidades();
    this.getConsorcios();
    this.getProveedoresAutocomplete();

    this.getMonedas();
    this.getBancos();
    this.getTiposDocumento();

    this.isRosbaco = this.sharedFunctions.isRosbacoUser();//this.getUserRolCheck();
  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'MonedaId': [this.monedaId],
      'VerSoloCuentaCorrienteInterna': [null]
    });

    this.proveedorFormGroup = this.formBuilder.group({
      'Proveedor': [null]
    });

    this.formGroup = this.formBuilder.group({
      'Codigo': [null, [Validators.maxLength(100)]],
      'BancoId': [null],
      'MonedaId': [this.monedaId, Validators.required],
      'ClaveBancaria': [null, [Validators.required, Validators.maxLength(100)]],
      'NumeroCuenta': [null, Validators.maxLength(100)],
      'Titular': [null, Validators.maxLength(100)],
      'Alias': [null, [Validators.required, Validators.maxLength(100)]]
  });
  }

  buildPersonForm() {
    this.personaFormGroup = this.formBuilder.group({
      'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
      'Apellido': [null, [Validators.required, Validators.maxLength(150)]],
      'TipoDocumentoId': [null],
      'NroDocumento': [null, Validators.maxLength(100)],
      'Cuit': [null, Validators.maxLength(100)],
      'FechaNacimiento': [null],
      'MailContacto': [null, [Validators.maxLength(255), Validators.email]],
      'MovilContacto': [null, Validators.maxLength(100)]
    });
  }

  isProcessing() {
    return (this.isProveedorAutoSearching || this.isConsorcioSearching || this.isComunidadSearching);
  }

//#region Getters

  getMonedas() {
    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
      this.isMonedaSearching = false;
      this.monedasList = data?.result;
    },
    (err: HttpErrorResponse) => {
        this.isMonedaSearching = false;
        this.sharedFunctions.handleError(err);
    })
  }

  getTiposDocumento() {
    if (!this.canAsociarPersona)
      return false;

    var r = new SearchTipoDocumentoRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoDocumentoSearching = true;

    this.tipoDocumentoService.search(r).subscribe(data => {
      this.isTipoDocumentoSearching = false;
      if (data != null) {
        this.tipoDocumentoList = data?.result;
      }
    },
    (err: HttpErrorResponse) => {
      this.isTipoDocumentoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getProveedoresAutocomplete() {
    if (!this.canAsociarProveedor)
        return false;

    this.proveedorFormGroup.get('Proveedor')?.valueChanges
      .pipe(
        filter(res => {
          return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.filteredProveedorList = [];
          this.isProveedorAutoSearching = true;
        }),
        switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
          .pipe(
            finalize(() => {
              this.isProveedorAutoSearching = false;
            }),
          )
        )
      )
      .subscribe((data: any) => {
        this.isProveedorAutoSearching = false;
        if (data != null && data.result != null){
            this.filteredProveedorList = data.result;
            // console.log(this.filteredProveedorList)
        }
        else
          this.filteredProveedorList = [];
        // (this.filteredProveedorList, 'lista proveedor')
      });
  }

  displayProveedor(proveedor: Proveedor): string {
    return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
  }

  getConsorcios() {
    if (!this.tenantFeatureFlags?.HabilitarGestionConsorcio)
      return;

    var r = new SearchConsorcioRequest(null, null, null, "", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      this.comunidadList = data?.result;
      this.ufComunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getBancos() {
    var r = new SearchBancoRequest(null, null, true, "Nombre", null, null, null, true);
    this.isBancoSearching = true;

    this.bancoService.search(r).subscribe(data => {
        this.isBancoSearching = false;
        this.bancosList = data?.result;
    },
    (err: HttpErrorResponse) => {
        this.isBancoSearching = false;
        this.sharedFunctions.handleError(err);
    });
  }

//#endregion

//#region Nueva Cuenta

  getErrorCodigo() {
    var v = this.formGroup.get('Codigo');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorClaveBancaria() {
    var v = this.formGroup.get('ClaveBancaria');
    if (v?.hasError('required'))
        return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorNumeroCuenta() {
    var v = this.formGroup.get('NumeroCuenta');
    if (v?.hasError('required'))
        return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorAlias() {
    var v = this.formGroup.get('Alias');
    if (v?.hasError('required'))
        return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
        return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMoneda() {
    var v = this.formGroup.get('MonedaId');
    if (v?.hasError('required'))
        return 'El campo es obligatorio';
    return '';
  }

//#endregion

//#region Seleccion

  onPersonSearchClick() {
    const dialogRef = this.dialog.open(DialogPersonaSearchComponent, {
      width: '90%',
      data: new DialogPersonaSearchComponentRequestDto(false, 0)
    });

    dialogRef.afterClosed().subscribe((result: DialogPersonaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {
        var u = (result.Items != null && result.Items.length > 0 ? result.Items[0] : null);
        this.nuevaPersona = false;

        this.persona = new Persona(0, null, null, null, null, null, null, null, null, null, true, null, null, null);
        if (u != null && u.Id > 0) {
          this.persona = new Persona(u.Id, u.Nombre, u.Apellido, u.NroDocumento, u.TipoDocumentoNombre, u.TipoDocumentoId, u.FechaNacimiento, u.Cuit, u.MailContacto, u.MovilContacto,
            u.Activo, u.FotoDniFrenteUrl, u.FotoDniDorsoUrl, u.FotoSelfieUrl);
          this.onSearch();
        }
      }
    });
  }

  onNewPersonClick() {
    this.nuevaPersona = true;
    this.persona = new Persona(0, null, null, null, null, null, null, null, null, null, true, null, null, null);

    this.buildPersonForm();
  }

  onProveedorSelect() {
    this.proveedor = this.proveedorFormGroup?.get("Proveedor")?.value;
    
    this.persona = null;
    this.comunidad = null;
    this.consorcio = null;
    this.unidadFuncional = null;
    this.ufComunidad = null;

    this.onSearch();
  }

  onPersonaSelect() {
    this.proveedor = null;
    this.comunidad = null;
    this.consorcio = null;
    this.unidadFuncional = null;
    this.ufComunidad = null;

    this.onSearch();
  }

  onComunidadSelect() {
    this.persona = null;
    this.proveedor = null;
    this.consorcio = null;
    this.unidadFuncional = null;
    this.ufComunidad = null;

    this.onSearch();
  }

  onConsorcioSelect() {
    this.persona = null;
    this.proveedor = null;
    this.comunidad = null;
    this.unidadFuncional = null;
    this.ufComunidad = null;

    this.onSearch();
  }

  onUfComunidadSelect() {
    this.unidadFuncional = null;
    if (this.ufComunidad == null || this.ufComunidad.Id == null || this.ufComunidad.Id <= 0) {
      this.ufList = [];
      return false;
    }

    var r = new SearchUnidadFuncionalRequest(null, null, true, "", null, null, null, null, null, null, this.ufComunidad?.Id, null, true);
    this.isUnidadesFuncionalesSearching = true;

    this.unidadFuncionalService.search(r).subscribe(data => {
      this.isUnidadesFuncionalesSearching = false;
      this.ufList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isUnidadesFuncionalesSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onUnidadFuncionalSelect() {
    this.persona = null;
    this.proveedor = null;
    this.comunidad = null;
    this.consorcio = null;

    this.onSearch();
  }

//#endregion

//#region Validators Persona

  getErrorNombre() {
    var v = this.personaFormGroup?.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorApellido() {
    var v = this.personaFormGroup?.get('Apellido');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorFechaNacimiento() {
    return this.personaFormGroup?.get('FechaNacimiento')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorTipoDocumentoId() {
    return this.personaFormGroup?.get('TipoDocumentoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorNroDocumento() {
    var v = this.personaFormGroup?.get('NroDocumento');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorCuit() {
    var v = this.personaFormGroup?.get('Cuit');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMailContacto() {
    var v = this.personaFormGroup?.get('MailContacto');
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    if (v?.hasError('email'))
      return 'Debe ingresar un email con formato válido';
    return '';
  }

  getErrorMovilContacto() {
    var v = this.personaFormGroup?.get('MovilContacto');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    if(v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

//#endregion

//#region Metodos Persona

  onTipoDocumentoSelection() {
    var tipoDoc: TipoDocumento | null = null;
    if (this.tipoDocumentoList != null)
      tipoDoc = (this.tipoDocumentoList.filter(f => f.Id == this.personaFormGroup?.get("TipoDocumentoId")?.value))[0];
    this.showCuit = !(tipoDoc?.Nombre?.toUpperCase() == "CUIT" || tipoDoc?.Nombre?.toUpperCase() == "CUIL");
    this.checkPersonaExistance(true, false);
  }

  onNroDocumentoChange() {
    this.checkPersonaExistance(true, false);
  }

  onCuitChange() {
    this.checkPersonaExistance(false, true);
  }

  checkPersonaExistance(searchByDoc: boolean, searchByCuit: boolean) {
    var tipoDocId = this.personaFormGroup?.get("TipoDocumentoId")?.value;
    var nroDoc = this.personaFormGroup?.get("NroDocumento")?.value;
    var cuit = this.personaFormGroup?.get("Cuit")?.value;

    if ((tipoDocId > 0 && nroDoc?.length > 0) || cuit?.length > 0) {
      var r = new SearchPersonaRequestDto(null, null, true, "Apellido", null, null, tipoDocId, nroDoc, null, null, null, true, false);
      if (searchByCuit)
        r = new SearchPersonaRequestDto(null, null, true, "Apellido", null, null, null, null, cuit, null, null, true, false);
      
      this.isPersonaDataSearching = true;

      this.personaService.search(r).subscribe(data => {
        this.isPersonaDataSearching = false;
        if (data != null && data.result != null && data.result.length > 0) {
          this.personaSearchResult = data?.result[0];

          if (this.personaSearchResult?.Id == this.persona?.Id) {
            this.personaSearchResult = null;
            return;
          }

          var msg = "Se encontró a la persona " + this.personaSearchResult?.Nombre + " " + this.personaSearchResult?.Apellido;
          if (searchByDoc) msg +=" en base al tipo y nro. de documento ingresado. ";
          if (searchByCuit) msg +=" en base al CUIT/CUIL ingresado. ";
          msg += "\n\n¿Desea cargar los datos encontrados?"

          const dialogRef = this.dialog.open(DialogConfirmComponent, {
            data: new DialogConfirmRequest("Persona encontrada", msg, "Sí, carga los datos", "No cargues nada")
          });

          dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
            if (result != null && result.Accepted)
              this.cargarPersonaEncontrada();
            else
              this.noCargarPersonaEncontrada();
          });
        }
      },
      (err: HttpErrorResponse) => {
        this.isPersonaDataSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  cargarPersonaEncontrada() {
    if (this.personaSearchResult != null && this.personaSearchResult.Id > 0) {
      if (this.cuenta != null)
        this.cuenta.PersonaId = this.personaSearchResult.Id;
      this.persona = this.personaSearchResult;

      this.personaSearchResult = null;
      this.nuevaPersona = false;
    }
  }

  noCargarPersonaEncontrada() {
    this.personaSearchResult = null;
  }

//#endregion

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onSearch() {
    var r = new SearchCuentaRequest(null, null, true, "", null, null, null, null, null, this.monedaId, (this.persona?.Id ?? null), (this.proveedor?.Id ?? null), 
      (this.comunidad?.Id ?? null), (this.consorcio?.Id ?? null), (this.unidadFuncional?.Id ?? null), null, true, null, this.verSoloCuentasConSaldo, null);
    r = { ...this.searchForm.value, ...r };

    this.isCuentaSearching = true;
    this.cuentaService.search(r).subscribe(data => {
      this.isCuentaSearching = false;
      this.cuentaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isCuentaSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onNewCuentaClick() {
    this.createNewCuenta = true;
  }

  onNewCuentaCancel() {
    this.createNewCuenta = false;
  }

  onSelect() {
    this.isSelecting = true;
    if (this.nuevaPersona && !((this.persona?.Id ?? 0) > 0)) {
      var r = new SavePersonaDto(0, null, null, null, null, null, null, null, null, true, null, null, null, null, null, null);

      r =
      {
        ...this.personaFormGroup.value,
        ...
        {
          Id: (this.persona?.Id ?? 0),
          Activo: this.persona?.Activo ?? true
        }
      };

      this.personaService.save(r).subscribe(data => {
        if (data != null && data.Success && data?.Result != null && data?.Result.Id > 0) {
          this.persona = data?.Result;
          this.persona.Id = data?.Result.Id;

          this.continueSelection();
        }
        else {
          this.isSelecting = false;
          this.sharedFunctions.showMessage("Ocurrió un error intentando dar de alta a la persona", "Error");
        }
      },
      (err: HttpErrorResponse) => {
        this.isSelecting = false;
        this.sharedFunctions.handleError(err, true);
      });
    }
    else
      this.continueSelection();
  }

  continueSelection() {
    if (this.createNewCuenta) {
      if (!this.formGroup.valid) {
        this.sharedFunctions.showMessage("Debe completar los campos obligatorios de la cuenta para continuar", "Error");
        this.isSelecting = false;
        return false;
      }

      var r = {
        ...this.getCuentaDefault(),
        ...this.formGroup.value,
        EsCuentaCorrienteInterna: false,
        ... {
          BancoNombre: this.bancosList?.find(f => f.Id == this.formGroup.get("BancoId")?.value)?.Nombre
        }
      };

      this.dialogRef.close(new DialogCuentaSearchComponentResponseDto(false, r));
    }
    else {
      if (this.cuentaList != null && this.cuentaList.length > 0) {
        if (this.cuentaList.length == 1) {
          this.dialogRef.close(new DialogCuentaSearchComponentResponseDto(false, this.cuentaList[0]));
        }
        else {
          const selectedrecords: any[] = this.grid.getSelectedRecords();
          if (selectedrecords == null || selectedrecords.length == 0) {
            this.sharedFunctions.showMessage("Debe seleccionar una cuenta para poder continuar con la operación", "Error");
            this.isSelecting = false;
            return false;
          }

          if (selectedrecords.length > 1) {
            this.sharedFunctions.showMessage("Debe seleccionar solo una cuenta para poder continuar con la operación (actualmente selecciono " + selectedrecords.length + " cuentas)", "Error");
            this.isSelecting = false;
            return false;
          }

          var cuentaResult = selectedrecords[0] as Cuenta;
          if (cuentaResult == null || cuentaResult.Id == null || cuentaResult.Id <= 0) {
            this.sharedFunctions.showMessage("Ocurrió un error al seleccionar la cuenta", "Error");
            this.isSelecting = false;
            return false;
          }
          
          this.dialogRef.close(new DialogCuentaSearchComponentResponseDto(false, cuentaResult));
        }
      }
      else {
        var cuentaResult = this.getCuentaDefault();
        this.dialogRef.close(new DialogCuentaSearchComponentResponseDto(false, cuentaResult));
      }
    }
  }

  getCuentaDefault() {
    var cuentaResult = new Cuenta(
      0,
      "", true,
      this.monedaId,
      null, null, null, null, null, null, null, true,
      (this.persona?.Id ?? null),
      (this.persona != null ? this.persona?.Nombre + " " + this.persona?.Apellido : null),
      (this.proveedor?.Id ?? null),
      (this.proveedor != null ? this.proveedor?.RazonSocial : null),
      (this.comunidad?.Id ?? null),
      (this.comunidad != null ? this.comunidad?.Nombre : null),
      (this.consorcio?.Id ?? null),
      (this.consorcio != null ? this.consorcio?.Nombre : null),
      (this.unidadFuncional?.Id ?? null),
      (this.unidadFuncional != null ? this.unidadFuncional?.Comunidad + " - " + this.unidadFuncional?.Codigo : null)
    );

    return cuentaResult;
  }

  onCancel() {
    this.dialogRef.close(new DialogCuentaSearchComponentResponseDto(true, null));
  }
}